<template>
  <div class="login">
    <!-- {{ initProjectList }} -->
    <mymenu />
    <div class="login-con">
      <img
        src="../../assets/images/loginbg.jpg"
        width="100%"
        height="100%"
        alt=""
      />
      <div class="register-form">
        <div class="register-inner">
          <h3 class="register_center">注册账户</h3>

          <!-- 0.注册验证 -->
          <div v-show="active === 0">
            <div class="input" style="margin-top: 20px">
              <el-input
                placeholder="请输入手机号"
                v-model="model.mobile"
                clearable
              >
              </el-input>
            </div>
            <!-- <div class="input clearfix">
              <div class="fl">
                <el-input
                  placeholder="请输入图片验证码"
                  v-model="model.captcha"
                  clearable
                >
                </el-input>
              </div>
              <div class="fr">
                <img @click="getCapt()" class="codeImg" :src="url" alt="" />
              </div>
            </div> -->
            <div class="input clearfix">
              <div class="fl">
                <el-input
                  placeholder="请输入验证码"
                  v-model="model.code"
                  clearable
                >
                </el-input>
              </div>
              <div class="fr">
                <el-button
                  v-show="wait == 0"
                  class="get-imgcode"
                  @click="getCode()"
                  >{{ content }}</el-button
                >
                <el-button
                  v-show="wait > 0"
                  class="get-imgcode"
                  disabled
                  style="font-size: 8px"
                  >{{ content }}</el-button
                >
              </div>
            </div>
            <div class="input">
              <el-input
                show-password
                placeholder="请输入密码"
                v-model="model.password"
                clearable
              >
              </el-input>
            </div>
            <div class="input">
              <el-input
                show-password
                placeholder="请再次输入密码"
                v-model="model.repassword"
                clearable
                @keyup.enter.native="userRegister()"
              >
              </el-input>
            </div>
            <div class="flex">
              <div class="input-comands" v-show="active !== 2">
                <el-checkbox @change="change" v-model="model.radio" label="0"
                  >我已阅读并接受<span class="agreement"
                    >考生注册协议</span
                  ></el-checkbox
                >
              </div>
              <div>
                <router-link to="/login" class="had-account"
                  >已有账号，去登录</router-link
                >
              </div>
            </div>
            <!-- 下一步 -->
            <div class="register_center" v-show="active == 0">
              <el-button class="login-btn" @click="userRegister()"
                >注册</el-button
              >
            </div>
          </div>

          <!-- <div class="finish-finish-tips" v-show="active === 2">
            <h2 class="finish-con-tips">温馨提示:</h2>
          </div> -->
          <!-- 协议 -->
        </div>
      </div>

      <!-- 注册协议 -->
      <el-dialog
        :visible.sync="centerDialogVisible"
        width="60%"
        center
        :modal="false"
      >
        <span v-html="initProjectList.apply_register"></span>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            type="info"
            @click="centerDialogVisible = false"
            >同意</el-button
          >
        </span>
      </el-dialog>
      <applyBottom></applyBottom>
    </div>
  </div>
</template>

<script>
import { getCapt, getCode, reqUserSafe, reqUserRegister } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
    }),
  },
  data() {
    return {
      active: 0,
      username: "",
      wait: localStorage.getItem("wait") ? localStorage.getItem("wait") : 0,
      content: "获取验证码",
      canClick: true,
      centerDialogVisible: false,
      url: "",
      stepData: [
        {
          index: 0,
          title: "注册验证",
          icon: "el-icon-edit",
        },
        {
          index: 1,
          title: "实名认证",
          icon: "el-icon-edit",
        },
        {
          index: 2,
          title: "完成注册",
          icon: "el-icon-edit",
        },
      ],

      agreement: "",
      model: {
        mobile: "",
        captcha_key: "",
        captcha: "",
        code: "",
        truename: "",
        type: "身份证",
        id_card: "",
        sex: "",
        password: "",
        radio: true,
      },
      documentTypeList: [
        {
          value: "香港地区身份证",
          label: "香港地区身份证",
        },
        {
          value: "澳门地区身份证",
          label: "澳门地区身份证",
        },
        {
          value: "台湾地区身份证",
          label: "台湾地区身份证",
        },
        {
          value: "身份证",
          label: "身份证",
        },
      ],
      value: "",
    };
  },
  created() {
    // this.getCapt();
    this.daojishi();
  },
  methods: {
    daojishi() {
      if (this.wait == 0) return;
      this.canClick = false;
      this.content = this.wait + "秒后重新发送"; //这里解决60秒不见了的问题
      let clock = window.setInterval(() => {
        this.wait--;
        localStorage.setItem("wait", this.wait);
        this.content = this.wait + "秒后重新发送";
        if (this.wait <= 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.content = "获取验证码";
          localStorage.setItem("wait", 0);
          this.canClick = true;
        }
      }, 1000);
    },
    getCapt() {
      getCapt().then((res) => {
        if (res.data.code == 1) {
          this.url = res.data.data.captcha;
          this.model.captcha_key = res.data.data.key;
        }
      });
    },
    next() {
      let that = this;
      if (that.active < 3) {
        that.active++;
      } else {
        that.active = 0;
      }
    },
    //注册验证
    nextOneActive() {
      let that = this;

      if (that.model.radio !== true) {
        erroralert("请勾选注册协议");
        return;
      }
      // that.next();
    },
    //用户注册
    userRegister() {
      let that = this;
      this.model.username = this.model.mobile;
      //用户注册
      reqUserRegister(that.model).then((res) => {
        if (res.data.code === 1) {
          successalert(res.data.msg);
          //存储用户token
          that.$router.push("/login");
        }
      });
    },
    //实名认证
    nextTwoActive() {
      let that = this;

      if (that.model.radio !== true) {
        erroralert("请勾选注册协议");
        return;
      }
      reqUserSafe(that.model).then((res) => {
        if (res.data.code === 1) {
          // successalert(res.data.msg);
          that.next();
          that.username = res.data.username;
        }
      });
    },

    change(e) {
      let that = this;
      if (that.model.radio == true) {
        that.centerDialogVisibleShow();
      } else {
        that.model.radio == false;
      }
    },
    centerDialogVisibleShow() {
      this.centerDialogVisible = true;
    },

    getCode() {
      if (this.timer > 0) {
        erroralert(this.timer + "秒后重新发送");
      }

      getCode(this.model).then((res) => {
        if (res.data.code === 1) {
          localStorage.setItem("wait", 45);
          this.wait = 45;
          this.canClick = false;
          this.daojishi();
          successalert(res.data.msg);
        } else {
          erroralert(res.data.msg);
          // this.getCapt();
        }
      });
    },
  },
};
</script>

<style scoped>
.input-comands {
  margin-right: 30px;
}

.had-account {
  color: #000;
}

.register-con-login span {
  color: #539fea;
}

.next-btn {
  margin: 10px auto;
  width: 345px;
}
</style>
